import { sideBarData } from "./datautils";
import { filterStaffSidebarByCapabilities } from "./investorPortalRouteCapabilities";
import { isSafeActionUrl } from "./safeActionUrl";
import {
  canAccessStaffPath,
  filterStaffSidebarByRoleModules,
  getRoleModuleUrls,
  isAlwaysVisibleStaffPath,
  isStaffDashboardPath,
  staffCanViewDashboard,
} from "./staffRoleModules";

function normalizePath(path = "") {
  return String(path).replace(/\/$/, "");
}

function sidebarAllowsPath(sidebarItems, targetPath) {
  const normalized = normalizePath(targetPath);
  const allowedPaths = [];

  sidebarItems.forEach((item) => {
    if (item.type === "section") return;
    if (item.path) allowedPaths.push(normalizePath(item.path));
    item.subMenu?.forEach((sub) => {
      if (sub.type !== "section" && sub.path) {
        allowedPaths.push(normalizePath(sub.path));
      }
    });
  });

  return allowedPaths.some(
    (allowed) =>
      allowed &&
      (normalized === allowed || normalized.startsWith(`${allowed}/`))
  );
}

/**
 * True when staff can open this portal path (sidebar + role modules + capabilities).
 */
export function staffCanNavigateToPath(pathname, role, capabilities = null) {
  const path = normalizePath(pathname);
  if (!path.startsWith("/super_admin")) return true;

  const roleMeta = getRoleModuleUrls(role);

  if (isAlwaysVisibleStaffPath(path)) return true;
  if (isStaffDashboardPath(path)) return staffCanViewDashboard(role);

  const filteredSidebar = filterStaffSidebarByRoleModules(
    filterStaffSidebarByCapabilities(sideBarData, capabilities),
    role
  );

  if (sidebarAllowsPath(filteredSidebar, path)) {
    return true;
  }

  return canAccessStaffPath(path, role);
}

/**
 * Resolve where to navigate when a notification is clicked.
 */
export function resolveNotificationNavigationTarget({
  actionUrl,
  guard = "staff",
  role = null,
  capabilities = null,
  notificationId,
  listPath,
}) {
  const detailPath = `${listPath}/${notificationId}`;

  if (!isSafeActionUrl(actionUrl)) {
    return { path: detailPath, usedFallback: true, reason: "unsafe_url" };
  }

  if (guard === "staff" && role) {
    if (!staffCanNavigateToPath(actionUrl, role, capabilities)) {
      return {
        path: detailPath,
        usedFallback: true,
        reason: "permission_denied",
        blockedUrl: actionUrl,
      };
    }
  }

  return { path: actionUrl, usedFallback: false };
}
